import { render, staticRenderFns } from "./systemDetailNotifyPop.vue?vue&type=template&id=791aeb56&scoped=true"
import script from "./systemDetailNotifyPop.vue?vue&type=script&setup=true&lang=js"
export * from "./systemDetailNotifyPop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./systemDetailNotifyPop.vue?vue&type=style&index=0&id=791aeb56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791aeb56",
  null
  
)

export default component.exports